import { remove, cloneDeep } from 'lodash'

const initialState = {
  currentContactUsers: [],
  currentContactList: undefined,
  currentListIndex: 0
}

const contactLists = (state = initialState, action) => {
  const { type, contactUsers, contactUser, contactList, listIndex } = action
  switch (type) {
    case 'SET_CURRENT_CONTACT_USERS':
      return { ...state, currentContactUsers: contactUsers }
    case 'SET_CURRENT_CONTACT_LIST':
      return { ...state, currentContactList: contactList }
    case 'SET_CURRENT_LIST_INDEX':
      return { ...state, currentListIndex: listIndex }
    case 'UPDATE_CURRENT_CONTACT_USER': {
      let newContactUsers = cloneDeep(state.currentContactUsers)
      // Make sure we don't lose certain info when updating the contact user
      const [oldContactUser] = remove(newContactUsers, ({ _id }) => _id === contactUser._id)
      if (!oldContactUser) return state
      const { todaysShifts = [], todaysTimeOffs = [], todaysAttendances = [] } = oldContactUser || {}
      return { ...state, currentContactUsers: [...newContactUsers, { ...contactUser, todaysShifts, todaysTimeOffs, todaysAttendances }] }
    }
    default:
      return state
  }
}

export default contactLists
